import $ from "jquery";
import { toast } from "react-toastify";
import { apiURL } from "../utlis/config";
import store from "store";
// const apiURL = "http://172.105.35.119:8080/api";
var Actions = {
  updateClientInfo: (info) => {
    toast.dismiss();
    return new Promise((resolve, reject) => {
      var url = apiURL + "/client";
      var settings = {
        async: true,
        crossDomain: true,
        url: url,
        method: "PUT",
        headers: {
          Authorization: "Bearer " + store.get("authToken"),
          // fngprt: m.cookie.get("fngprt")
        },
        data: info,
        success: function (response) {
          // response = JSON.parse(response);
          if (response.error) {
            toast.error(response.memberMessage);
          } else {
            toast.info(response.memberMessage);
          }
          resolve(response);
        },
        error: function (error) {
          if (error.status == 401) {
            // message.error("Your session has been expired. Please relogin.");
            localStorage.clear();
            window.location.reload();
          } else if (error.statusText === "abort") {
          } else {
            // message.error("Some error has occurred.");
          }
        },
      };
      $.ajax(settings).done();
    });
  },
  fetchClientsInfo: (
    clientId,
    clientStatus,
    page,
    pageSize,
    searchText,
    startDate,
    endDate
  ) => {
    toast.dismiss();
    return new Promise((resolve, reject) => {
      var url = apiURL + "/client";
      var settings = {
        async: true,
        crossDomain: true,
        url: url,
        method: "GET",
        headers: {
          Authorization: "Bearer " + store.get("authToken"),
        },
        data: {
          clientId: clientId,
          clientStatus: clientStatus,
          limit: pageSize,
          page: page,
          searchText: searchText !== "" ? searchText : undefined,
          startDate:
            startDate !== "" && startDate !== "Invalid date"
              ? startDate
              : undefined,
          endDate:
            endDate !== "" && endDate !== "Invalid date" ? endDate : undefined,
        },
        success: function (response) {
          if (!response.error) {
            toast.info(
              response.memberMessage,
              {
                position: toast.POSITION.TOP_CENTER,
              },
              { autoClose: 500 }
            );
          } else {
            if (!clientId) {
              toast.error(
                response.memberMessage,
                {
                  position: toast.POSITION.TOP_CENTER,
                },
                { autoClose: 500 }
              );
            }
          }
          resolve(response);
        },
        error: function (error) {
          if (error.status == 401) {
            toast.error(
              "Your session has been expired. Please relogin.",
              {
                position: toast.POSITION.TOP_CENTER,
              },
              { autoClose: 500 }
            );
            localStorage.clear();
            window.location.reload();
          } else if (error.statusText === "abort") {
          } else {
            toast.error(
              "Some error has occurred.",
              {
                position: toast.POSITION.TOP_CENTER,
              },
              { autoClose: 500 }
            );
          }
        },
      };
      $.ajax(settings).done();
    });
  },
  deactivateClientId: (clientId) => {
    //deactivateMemberId
    toast.dismiss();
    return new Promise((resolve, reject) => {
      var url = apiURL + "/client";
      var settings = {
        async: true,
        crossDomain: true,
        url: url,
        method: "DELETE",
        headers: {
          Authorization: "Bearer " + store.get("authToken"),
          // fngprt: m.cookie.get("fngprt")
        },
        data: { clientId },

        success: function (response) {
          if (!response.error) {
            toast.info(
              response.memberMessage,
              {
                position: toast.POSITION.TOP_CENTER,
              },
              { autoClose: 500 }
            );
          } else {
            toast.error(
              response.memberMessage,
              {
                position: toast.POSITION.TOP_CENTER,
              },
              { autoClose: 500 }
            );
          }
          resolve(response);
        },
        error: function (error) {
          if (error.status == 401) {
            toast.error(
              "Your session has been expired. Please relogin.",
              {
                position: toast.POSITION.TOP_CENTER,
              },
              { autoClose: 500 }
            );
            localStorage.clear();
            window.location.reload();
          } else if (error.statusText === "abort") {
          } else {
            toast.error(
              "Some error has occurred.",
              {
                position: toast.POSITION.TOP_CENTER,
              },
              { autoClose: 500 }
            );
          }
        },
      };

      $.ajax(settings).done();
    });
  },
  updateEnquiryInfo: (info) => {
    toast.dismiss();
    return new Promise((resolve, reject) => {
      var url = apiURL + "/client/enquiries";
      var settings = {
        async: true,
        crossDomain: true,
        url: url,
        method: "PUT",
        headers: {
          Authorization: "Bearer " + store.get("authToken"),
          // fngprt: m.cookie.get("fngprt")
        },
        data: info,
        success: function (response) {
          // response = JSON.parse(response);
          if (response.error) {
            toast.error(response.memberMessage);
          } else {
            toast.info(response.memberMessage);
          }
          resolve(response);
        },
        error: function (error) {
          if (error.status == 401) {
            // message.error("Your session has been expired. Please relogin.");
            localStorage.clear();
            window.location.reload();
          } else if (error.statusText === "abort") {
          } else {
            // message.error("Some error has occurred.");
          }
        },
      };
      $.ajax(settings).done();
    });
  },
  fetchEnquiriesInfo: (
    enquiryId,
    clientId,
    enquiryStatus,
    page,
    pageSize,
    searchText,
    startDate,
    endDate
  ) => {
    toast.dismiss();
    return new Promise((resolve, reject) => {
      var url = apiURL + "/client/enquiries";
      var settings = {
        async: true,
        crossDomain: true,
        url: url,
        method: "GET",
        headers: {
          Authorization: "Bearer " + store.get("authToken"),
        },
        data: {
          enquiryId: enquiryId,
          clientId: clientId,
          enquiryStatus: enquiryStatus,
          limit: pageSize,
          page: page,
          searchText: searchText !== "" ? searchText : undefined,
          startDate:
            startDate !== "" && startDate !== "Invalid date"
              ? startDate
              : undefined,
          endDate:
            endDate !== "" && endDate !== "Invalid date" ? endDate : undefined,
        },
        success: function (response) {
          if (!response.error) {
            toast.info(
              response.memberMessage,
              {
                position: toast.POSITION.TOP_CENTER,
              },
              { autoClose: 500 }
            );
          } else {
            if (!enquiryId) {
              toast.error(
                response.memberMessage,
                {
                  position: toast.POSITION.TOP_CENTER,
                },
                { autoClose: 500 }
              );
            }
          }
          resolve(response);
        },
        error: function (error) {
          if (error.status == 401) {
            toast.error(
              "Your session has been expired. Please relogin.",
              {
                position: toast.POSITION.TOP_CENTER,
              },
              { autoClose: 500 }
            );
            localStorage.clear();
            window.location.reload();
          } else if (error.statusText === "abort") {
          } else {
            toast.error(
              "Some error has occurred.",
              {
                position: toast.POSITION.TOP_CENTER,
              },
              { autoClose: 500 }
            );
          }
        },
      };
      $.ajax(settings).done();
    });
  },
  fetchEnquiriesRequestInfo: (
    enquiryId,
    clientId,
    enquiryStatus,
    page,
    pageSize,
    searchText,
    startDate,
    endDate
  ) => {
    toast.dismiss();
    return new Promise((resolve, reject) => {
      var url = apiURL + "/client/enquiries";
      var settings = {
        async: true,
        crossDomain: true,
        url: url,
        method: "GET",
        headers: {
          Authorization: "Bearer " + store.get("authToken"),
        },
        data: {
          contactUs: true,
          enquiryId: enquiryId,
          clientId: clientId,
          enquiryStatus: enquiryStatus,
          limit: pageSize,
          page: page,
          searchText: searchText !== "" ? searchText : undefined,
          startDate:
            startDate !== "" && startDate !== "Invalid date"
              ? startDate
              : undefined,
          endDate:
            endDate !== "" && endDate !== "Invalid date" ? endDate : undefined,
        },
        success: function (response) {
          if (!response.error) {
            toast.info(
              response.memberMessage,
              {
                position: toast.POSITION.TOP_CENTER,
              },
              { autoClose: 500 }
            );
          } else {
            if (!enquiryId) {
              toast.error(
                response.memberMessage,
                {
                  position: toast.POSITION.TOP_CENTER,
                },
                { autoClose: 500 }
              );
            }
          }
          resolve(response);
        },
        error: function (error) {
          if (error.status == 401) {
            toast.error(
              "Your session has been expired. Please relogin.",
              {
                position: toast.POSITION.TOP_CENTER,
              },
              { autoClose: 500 }
            );
            localStorage.clear();
            window.location.reload();
          } else if (error.statusText === "abort") {
          } else {
            toast.error(
              "Some error has occurred.",
              {
                position: toast.POSITION.TOP_CENTER,
              },
              { autoClose: 500 }
            );
          }
        },
      };
      $.ajax(settings).done();
    });
  },
  deactivateEnquiryId: (enquiryId) => {
    //deactivateMemberId
    toast.dismiss();
    return new Promise((resolve, reject) => {
      var url = apiURL + "/client/enquiries";
      var settings = {
        async: true,
        crossDomain: true,
        url: url,
        method: "DELETE",
        headers: {
          Authorization: "Bearer " + store.get("authToken"),
          // fngprt: m.cookie.get("fngprt")
        },
        data: { enquiryId },

        success: function (response) {
          if (!response.error) {
            toast.info(
              response.memberMessage,
              {
                position: toast.POSITION.TOP_CENTER,
              },
              { autoClose: 500 }
            );
          } else {
            toast.error(
              response.memberMessage,
              {
                position: toast.POSITION.TOP_CENTER,
              },
              { autoClose: 500 }
            );
          }
          resolve(response);
        },
        error: function (error) {
          if (error.status == 401) {
            toast.error(
              "Your session has been expired. Please relogin.",
              {
                position: toast.POSITION.TOP_CENTER,
              },
              { autoClose: 500 }
            );
            localStorage.clear();
            window.location.reload();
          } else if (error.statusText === "abort") {
          } else {
            toast.error(
              "Some error has occurred.",
              {
                position: toast.POSITION.TOP_CENTER,
              },
              { autoClose: 500 }
            );
          }
        },
      };

      $.ajax(settings).done();
    });
  },
  // onEnquiryStatus,

  onEnquiryStatus: (enquiryId, isApproved) => {
    toast.dismiss();
    return new Promise((resolve, reject) => {
      var url = apiURL + "/client/enquiries";
      var settings = {
        async: true,
        crossDomain: true,
        url: url,
        method: "PUT",
        headers: {
          Authorization: "Bearer " + store.get("authToken"),
        },
        data: { isApproved: isApproved, enquiryId: enquiryId },
        success: function (response) {
          if (response.error) {
            toast.error(response.memberMessage);
          } else {
            if (isApproved) {
              toast.info("Enquiry approved successfully");
            } else {
              toast.info("Enquiry disapproved successfully");
            }
          }
          resolve(response);
        },
        error: function (error) {
          if (error.status == 401) {
            // message.error("Your session has been expired. Please relogin.");
            localStorage.clear();
            window.location.reload();
          } else if (error.statusText === "abort") {
          } else {
            // message.error("Some error has occurred.");
          }
        },
      };
      $.ajax(settings).done();
    });
  },

  onClientStatus: (clientId, isApproved) => {
    toast.dismiss();
    return new Promise((resolve, reject) => {
      var url = apiURL + "/client";
      var settings = {
        async: true,
        crossDomain: true,
        url: url,
        method: "PUT",
        headers: {
          Authorization: "Bearer " + store.get("authToken"),
        },
        data: { isApproved: isApproved, clientId: clientId },
        success: function (response) {
          if (response.error) {
            toast.error(response.memberMessage);
          } else {
            if (isApproved) {
              toast.info("Enquiry approved successfully");
            } else {
              toast.info("Enquiry disapproved successfully");
            }
          }
          resolve(response);
        },
        error: function (error) {
          if (error.status == 401) {
            // message.error("Your session has been expired. Please relogin.");
            localStorage.clear();
            window.location.reload();
          } else if (error.statusText === "abort") {
          } else {
            // message.error("Some error has occurred.");
          }
        },
      };
      $.ajax(settings).done();
    });
  },
};

export default Actions;
